import {
  animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";
import {
  Component,
  ElementRef,
  EventEmitter,
  forwardRef,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";

const INLINE_EDIT_CONTROL_VALUE_ACCESSOR = {
  provide: NG_VALUE_ACCESSOR,
  // tslint:disable-next-line
  useExisting: forwardRef(() => InlineEditComponent),
  multi: true,
};

import { CommonModule } from "@angular/common";

@Component({
  selector: "app-inline-edit",
  standalone: true,
  imports: [CommonModule],
  templateUrl: "inline-edit.component.html",
  styleUrls: ["inline-edit.component.scss"],
  providers: [INLINE_EDIT_CONTROL_VALUE_ACCESSOR],
  animations: [
    trigger("editState", [
      state(
        "edit",
        style({
          opacity: 1,
        })
      ),
      state(
        "void",
        style({
          opacity: 0,
        })
      ),
      transition("void => *", animate("100ms ease-in")),
      transition("* => void", animate("100ms ease-out")),
    ]),
  ],
})
export class InlineEditComponent implements ControlValueAccessor, OnInit {
  @ViewChild("inputEditorControl", { static: true })
  inputEditorControl: ElementRef; // input DOM element
  @Input() label = ""; // Label value for input element
  @Input() placeholder = ""; // Placeholder value ofr input element
  @Input() type = "text"; // The type of input element
  @Input() required = false; // Is input requried?
  @Input() requiredMessage = "";
  @Input() disabled = true; // Is input disabled? 25-08-2019 -> Set to true, Cause input field doesnt match candidate model
  @Input() id = "";
  @Input() stringlength = "";
  @Output() Save: EventEmitter<string> = new EventEmitter();
  @Output() Cancel: EventEmitter<string> = new EventEmitter();
  @Output() Editing: EventEmitter<string> = new EventEmitter();

  private _originalValue: any;
  private _value = ""; // Private variable for input value
  private preValue = ""; // The value before clicking to edit
  public mode = "view"; // Is Component in edit mode?
  onChange: any = Function.prototype; // Trascend the onChange event
  onTouched: any = Function.prototype; // Trascend the onTouch event
  inputReqflag = false;

  constructor() {}

  onSaveInput() {
    if (this.required) {
      if (
        this.inputEditorControl.nativeElement.value == null ||
        this.inputEditorControl.nativeElement.value === undefined ||
        this.inputEditorControl.nativeElement.value === ""
      ) {
        this.inputReqflag = true;
        return;
      } else {
        this.inputReqflag = false;
      }
    } else {
      this.inputReqflag = false;
    }

    if (this._originalValue !== this._value) {
      this.Save.emit("clicked save");
    }

    this.mode = "view";
  }

  onCancelInput() {
    this.mode = "view";
    this._value = this._originalValue;
    this.inputReqflag = false;
    this.Cancel.emit("clicked cancel");
  }

  onCloseInput() {
    this.mode = "view";
    this.inputReqflag = false;
  }

  // Control Value Accessors for ngModel
  get value(): any {
    return this._value;
  }

  @Input()
  set value(v: any) {
    if (v !== this._value) {
      this._value = v;
      this.onChange(v);
    }
  }

  // Required for ControlValueAccessor interface
  writeValue(value: any) {
    this._value = value;
  }

  // Required forControlValueAccessor interface
  public registerOnChange(fn: (_: any) => {}): void {
    this.onChange = fn;
  }

  // Required forControlValueAccessor interface
  public registerOnTouched(fn: () => {}): void {
    this.onTouched = fn;
  }

  // Do stuff when the input element loses focus
  onBlur($event: Event) {
    this.onSaveInput();

    // Check if its the save button we clicked
    // if (($event as any).relatedTarget && ($event as any).relatedTarget.type === 'button') {
    //   this.onSaveInput();
    // } else {
    //   this.onCancelInput();
    // }
  }

  // Start the editting process for the input element
  edit(value: any) {
    if (this.disabled === true) {
      return;
    }

    this.Editing.emit("editing click");

    this.preValue = value;
    this.mode = "edit";
    this._originalValue = value;

    setTimeout(() => {
      this.inputEditorControl.nativeElement.focus();
      this.inputEditorControl.nativeElement.select();
    }, 50);
  }

  IsInputTextEmpty(): boolean {
    return this._value === undefined || this._value === "";
  }

  ngOnInit() {}
}
